import { render, staticRenderFns } from "./CategoryCardList.vue?vue&type=template&id=7ae480b2&scoped=true&"
import script from "./CategoryCardList.vue?vue&type=script&lang=js&"
export * from "./CategoryCardList.vue?vue&type=script&lang=js&"
import style0 from "./CategoryCardList.vue?vue&type=style&index=0&id=7ae480b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae480b2",
  null
  
)

export default component.exports